<template>
  <router-link tag="li" :class="className" exact-active-class="active" class="ga-event" data-category="Sidebar"
  :to="{ name: url , params :  params, hash: hash  }"  @click.native="closeMenu">
    <slot></slot>
    <div class="nav-badge" v-if="badge.length > 0">{{ badge }}</div>
  </router-link>
</template>

<script>

export default {
  name: 'SideNavLink',
  props: {
    url: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: true,
    },
    params: {
      required: false,
    },
    hash: {
      type: String,
      required: false,
      default: '',
    },
    badge: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    closeMenu() {
      this.$parent.$emit('close-menu');
    },
  },
};

</script>

<style scoped lang="scss">
/* v-ga="$ga.commands.ga.bind(this, {category: 'AgentPortal', action: 'Sidebar Navigation - Click', label: url})" */
  .nav-badge {
    @apply ut-ml-10 ut-rounded ut-text-center ut-opacity-75 ut-inline-block ut-text-neutral-900 ut-bg-neutral-100;
    height: 14px;
    width: 50px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.08px;
    line-height: 14px;
  }
</style>
